import React from 'react'
import { Upload } from '@fielded/shared-ui/src/icons'
import { Link } from 'react-router-dom'
import { Button } from '@fielded/shared-ui'

export const UploadOutboundsShipmentLink = ({
  url
}) => {
  const redirectUrl = url || '/shipments/export-import/download'
  return (
    <Button
      fill='full'
      colorVariant='brand'
      size='regular'
      component={Link}
      to={redirectUrl}
      icon={<Upload />}
    >
      Import shipment
    </Button>
  )
}
